import { Injectable } from '@angular/core';
import { AttrIndexService } from './attr-index.service';
import { EditService } from './edit.service';
import { RCRecordItem, ResoCenterCol } from './resolution-center.service';

interface QcCheckOutput {
	code: string;
	isFailed: boolean;
}
export type ParityValue = 'O' | 'E' | 'Z' | 'B';

@Injectable({
  providedIn: 'root'
})
export class ResolutionQcService {

	constructor(
		private attrIndexService: AttrIndexService,
		private editServie: EditService
	) { }
	// qcCheckCenterline(props, changedCols: string[]) {
	// 	const fromR = this.attrIndexService.fromAddrRightColName;
	// 	const toR = this.attrIndexService.toAddrRightColName;
	// 	const fromL = this.attrIndexService.fromAddrLeftColName;
	// 	const toL = this.attrIndexService.toAddrLeftColName;
	// 	const parityR = this.attrIndexService.parityRightColName;
	// 	const parityL = this.attrIndexService.parityLeftColName;
	// 	const map = {
	// 		ADN: {
	// 			cols: [fromR, toR, fromL, toL],
	// 			func: this.checkADN
	// 		},
	// 		ADR: {
	// 			cols: [fromR, toR, fromL, toL],
	// 			func: this.checkADR
	// 		},
	// 		AOE: {
	// 			cols: [fromR, toR, fromL, toL, parityR, parityL],
	// 			func: this.checkAOE
	// 		},
	// 		ARG: {
	// 			cols: [fromR, toR, fromL, toL],
	// 			func: this.checkARG
	// 		},
	// 		RAO: {
	// 			cols: [fromR, toR, fromL, toL],
	// 			func: this.checkRAO
	// 		}
	// 	}
	// }
	
	// qcCheckAddress(records: any[], changedCols: string[], davCols?: string[], davLCols?: string[]): QcCheckOutput[] {
	// 	const addressNum = this.attrIndexService.addrAddNumCol;
	// 	const map: {
	// 		[code: string]: {
	// 			cols?: string[];
	// 			func: Function;
	// 		}
	// 	} = {
	// 		ASQ: {
	// 			cols: [addressNum],
	// 			func: () => this.checkASQ(records)
	// 		},
	// 		DAV: {
	// 			cols: davCols,
	// 			func: () => this.checkDAV(records, davCols)
	// 		},
	// 		DAVL: {
	// 			cols: davLCols,
	// 			func: () => this.checkDAV(records, davLCols)
	// 		}
	// 	}
	// 	const checkingCodes = Object.keys(map).filter(code => map[code].cols && map[code].cols.find(c => changedCols.find(changedCol => changedCol === c)));
	// 	return checkingCodes.map(code => {
	// 		return {
	// 			code: code,
	// 			isFailed: map[code].func()
	// 		}
	// 	});
	// }
	qcCheckGeneral(records: RCRecordItem[], cols: ResoCenterCol[], elemRef): QcCheckOutput[] {
		const codes: QcCheckOutput[] = [];
		const invalidPatternElem = elemRef.nativeElement.querySelectorAll('input[pattern].ng-invalid');
		if (invalidPatternElem) {
			codes.push({
				code: 'DPT',
				isFailed: true
			});
		}
		const invalidDomainElem = elemRef.nativeElement.querySelectorAll('select.invalid-select');
		if (invalidDomainElem) {
			codes.push({
				code: 'DLS',
				isFailed: true
			});
		}
		const missingValueElem = cols.find(c => {
			if (c.require === 'M') {
				return !!records.find(i => !i.props[c.prop] && i.props[c.prop] !== 0);
			}
		});
		if (missingValueElem) {
			codes.push({
				code: 'MSV',
				isFailed: true
			});
		}
		return codes;
	}

	checkADN(props, geomLength) {
		if (!geomLength && geomLength !== 0) {
			return;
		}
		return Math.abs(props[this.attrIndexService.fromAddrRightColName] - props[this.attrIndexService.toAddrRightColName]) / (geomLength + 1) > 1.234 ||
		Math.abs(props[this.attrIndexService.fromAddrLeftColName] - props[this.attrIndexService.toAddrLeftColName]) / (geomLength + 1) > 1.234;
	}
	checkADR(props) {
		const fail = props[this.attrIndexService.fromAddrLeftColName] > props[this.attrIndexService.toAddrLeftColName] || props[this.attrIndexService.fromAddrRightColName] > props[this.attrIndexService.toAddrRightColName];
		return fail;
	}
	checkAOE(props) {
		let fail: boolean;
		const fromR = props[this.attrIndexService.fromAddrRightColName];
		const toR = props[this.attrIndexService.toAddrRightColName];
		const fromL = props[this.attrIndexService.fromAddrLeftColName];
		const toL = props[this.attrIndexService.toAddrLeftColName];
		switch (props[this.attrIndexService.parityRightColName]) {
			case 'E':
				fail = fromR % 2 === 1 || toR % 2 === 1;
				break;
			case 'O':
				fail = fromR % 2 === 0 || toR % 2 === 0;
				break;
			case 'Z':
				fail = fromR > 0 || toR > 0;
				break;
			// case 'B':
			// 	fail = (fromR + toR) % 2 === 0
			// 	break;
			default:
				fail = (fromR + toR) % 2 !== 0 || // <> 0
				(fromR === 0 && toR > 0) ||
				(fromR > 0 && toR === 0)
				break;
		}
		if (fail) {
			return fail;
		}
		switch (props[this.attrIndexService.parityLeftColName]) {
			case 'E':
				fail = fromL % 2 === 1 || toL % 2 === 1;
				break;
			case 'O':
				fail = fromL % 2 === 0 || toL % 2 === 0;
				break;
			case 'Z':
				fail = fromL > 0 || toL > 0;
				break;
			// case 'B':
			// 	fail = (fromL + toL) % 2 === 0
			// 	break;
			default:
				fail = (fromL + toL) % 2 !== 0 || // <> 0
				(fromL === 0 && toL > 0) ||
				(fromL > 0 && toL === 0)
				break;
		}
		return fail;			
	}
	checkARG(props) {
		const fromR = props[this.attrIndexService.fromAddrRightColName];
		const toR = props[this.attrIndexService.toAddrRightColName];
		const fromL = props[this.attrIndexService.fromAddrLeftColName];
		const toL = props[this.attrIndexService.toAddrLeftColName];
		const fail = Math.abs(Math.abs(fromR - toR ) - Math.abs(fromL - toL)) > 50;
		return fail;		
	}
		// checkRAO(props1, props2) {
		// 	if (props1[this.attrIndexService.parityLeftColName] !== 'Z' && props2[this.attrIndexService.parityLeftColName] !== 'Z') {
		// 		if (props1[this.attrIndexService.toAddrLeftColName] >= props2[this.attrIndexService.fromAddrLeftColName]) {
		// 			return true;
		// 		}
		// 	}
		// 	if (props1[this.attrIndexService.parityRightColName] !== 'Z' && props2[this.attrIndexService.parityRightColName] !== 'Z') {
		// 		if (props1[this.attrIndexService.toAddrRightColName] >= props2[this.attrIndexService.fromAddrRightColName]) {
		// 			return true;
		// 		}
		// 	}
		// 	return false;
		// }

	checkDAV(propsList: any[], cols: string[]) {
		if (propsList.length <= 1) {
			return;
		}
		let fail: boolean;
		for (let i = 0; i < propsList.length - 1; i++) {
			for (let j = i + 1; j < propsList.length; j++) {
				const changedCol = cols.find(c => {
					return this.editServie.hasValueChanged(propsList[i][c], propsList[j][c]);
				});
				if (!changedCol) {
					fail = true;
					return fail;
				}
			}
		}
		return fail;
	}
	checkASQ(propsList: any[]) {
		const addressList: number[] = propsList.map(r => r[this.attrIndexService.addrAddNumCol]);
		if (addressList.length <= 2) {
			return;
		}
		const isAscending = addressList[0] < addressList[1];
		for (let i = 1; i < addressList.length - 1; i++) {
			if (isAscending !== (addressList[i] < addressList[i + 1])) {
				return true;
			}
		}
	}

	getParity(from: number, to: number) {
		let parity: ParityValue;
		if (from === to && from === 0) {
			parity = 'Z';
		} else if (from % 2 === 0 && to % 2 === 0) {
			parity = 'E';
		} else if (from % 2 === 1 && to % 2 === 1) {
			parity = 'O';
		} else if ((from + to) % 2 !== 0) {
			parity = 'B';
		}
		return parity;
	}
}
